/**
 * @module msysCron
 * @description
 * Module for CRON like functions
 * Example of use:
 * const mcron = require('msysCron')
 * dt = mcron.findClosestMatchingTime('0 4 * 3? 1/2 Wed')
 */

const mcron = module.exports = {}

const MAX_YEARS_LOOK_AHEAD = 20
const SCHEDULE_MAX_YEARS_LOOK_AHEAD = 1
const DAY_NAMES = { SUN: 0, MON: 1, TUE: 2, WED: 3, THU: 4, FRI: 5, SAT: 6 }
const MONTH_NAMES = { JAN: 1, FEB: 2, MAR: 3, APR: 4, MAY: 5, JUN: 6, JUL: 7, AUG: 8, SEP: 9, OCT: 10, NOV: 11, DEC: 12 }

function mask2regexp(mask) {
  if(mask==='*') return '.+'

  // translate symbolic names
  mask = mask.replace(/WEEKDAY/gi, '1|2|3|4|5')
  mask = mask.replace(/WEEKEND/gi, '0|6')
  mask = mask.replace(/\b(\w+)\b/g, (m, p1)=>{
    p1 = p1.slice(0, 3).toUpperCase()
    return MONTH_NAMES[p1] || DAY_NAMES[p1] || p1
  })

  let m = /^(\*|\d+|)\/(\d+)$/.exec(mask)
  if(m) {
    const start = parseInt(m[1])||0
    const x = []
    const increment = parseInt(m[2])
    for(let i=start; i<60; i+=increment) {
      x.push(i)
    }
    return x.join('|')
  }

  m = /^(\d+)-(\d+)$/.exec(mask)
  if(m) {
    const [start, end] = [parseInt(m[1]), parseInt(m[2])]
    const x = []
    for(let i=start; i<=end; i++) {
      x.push(i)
    }
    return x.join('|')
  }

  mask = mask.replace(/\?/g, '.')

  return mask
} // mask2regexp

function masks2regexps(masks) {
  if(masks===null || typeof (masks)==='undefined') return []
  return masks.split(' ').map(mask=>new RegExp('^(' +mask.split(',').map(mask2regexp).join('|')+')$'))
} // masks2regexps

mcron.findClosestMatchingTime = function(masks, start_dt, end_dt) {
  masks = String(masks??'')
  if(masks==='') return
  if(start_dt) {
    start_dt = new Date(start_dt)
  }else{
    start_dt = new Date()
    start_dt.setSeconds(start_dt.getSeconds()+1)
  }
  start_dt.setMilliseconds(0)

  if(end_dt) {
    end_dt = new Date(end_dt)
  }else{
    end_dt = new Date(start_dt)
    end_dt.setFullYear(end_dt.getFullYear()+MAX_YEARS_LOOK_AHEAD)
  }
  end_dt.setMilliseconds(0)

  const regexps = masks2regexps(masks)
  const re_second = regexps[0]
  const re_minute = regexps[1] || /^.+$/
  const re_hour = regexps[2] || /^.+$/
  const re_day = regexps[3] || /^.+$/
  const re_month = regexps[4] || /^.+$/
  const re_wday = regexps[5] || /^.+$/

  const dt = new Date(start_dt)

  // MATCH SECOND
  if(re_month.test(dt.getMonth()+1) && re_wday.test(dt.getDay()) && re_day.test(dt.getDate()) && re_hour.test(dt.getHours()) && re_minute.test(dt.getMinutes())) {
    // all except seconds is OK, so we can try to find matching second after the current second
    let i
    for(i=dt.getSeconds(); i<60 && !re_second.test(i); i++);
    if(i<60) {
      dt.setSeconds(i)
      return dt
    }
  }
  dt.setMinutes(dt.getMinutes()+1)
  let i
  for(i=0; i<60 && !re_second.test(i); i++);
  if(i===60) return // no matching second found
  dt.setSeconds(i)

  // MATCH MINUTE
  if(re_month.test(dt.getMonth()+1) && re_wday.test(dt.getDay()) && re_day.test(dt.getDate()) && re_hour.test(dt.getHours())) {
    // all except minutes is OK, so we can try to find matching minute after the current minute
    let i
    for(i=dt.getMinutes(); i<60 && !re_minute.test(i); i++);
    if(i<60) {
      dt.setMinutes(i)
      return dt
    }
  }
  dt.setHours(dt.getHours()+1)
  for(i=0; i<60 && !re_minute.test(i); i++);
  if(i===60) return // no matching minute found
  dt.setMinutes(i)

  // MATCH HOUR
  if(re_month.test(dt.getMonth()+1) && re_wday.test(dt.getDay()) && re_day.test(dt.getDate())) {
    // all except hours is OK, so we can try to find matching hour after the current hour
    let i
    for(i=dt.getHours(); i<24 && !re_hour.test(i); i++);
    if(i<24) {
      dt.setHours(i)
      return dt
    }
  }
  dt.setDate(dt.getDate()+1)
  for(i=0; i<24 && !re_hour.test(i); i++);
  if(i===24) return // no matching hour found
  dt.setHours(i)

  // iterate over days to find the one completely matching the requirements
  // it is not as easy as hours/minutes/seconds, because of weekdays and the fact, that different months have different number of days
  while(dt.valueOf()<end_dt.valueOf()) {
    if(re_month.test(dt.getMonth()+1) && re_wday.test(dt.getDay()) && re_day.test(dt.getDate())) {
      return dt
    }
    dt.setDate(dt.getDate()+1)
  }
} // findClosestMatchingTime

mcron.isMatchingTime = function(masks, dt) {
  masks = String(masks??'')
  if(masks==='') return false
  if(!dt) return false
  dt = new Date(dt)
  if(isNaN(dt.valueOf())) return false
  dt.setMilliseconds(0)

  const regexps = masks2regexps(masks)
  const re_second = regexps[0]
  const re_minute = regexps[1] || /^.+$/
  const re_hour = regexps[2] || /^.+$/
  const re_day = regexps[3] || /^.+$/
  const re_month = regexps[4] || /^.+$/
  const re_wday = regexps[5] || /^.+$/

  return re_month.test(dt.getMonth()+1) && re_wday.test(dt.getDay()) && re_day.test(dt.getDate()) && re_hour.test(dt.getHours()) && re_minute.test(dt.getMinutes()) && re_second.test(dt.getSeconds())
} // isMatchingTime

mcron.schedule = function(masks, fcn, start_dt, end_dt, just_once = false) {
  masks = String(masks??'')
  if(masks==='') return
  if(typeof fcn!=='function') return

  if(start_dt) {
    start_dt = new Date(start_dt)
  }else{
    start_dt = new Date()
    start_dt.setSeconds(start_dt.getSeconds()+1)
  }
  start_dt.setMilliseconds(0)

  if(end_dt) {
    end_dt = new Date(end_dt)
  }else{
    end_dt = new Date(start_dt)
    end_dt.setFullYear(end_dt.getFullYear()+SCHEDULE_MAX_YEARS_LOOK_AHEAD)
  }
  end_dt.setMilliseconds(0)

  const dt = mcron.findClosestMatchingTime(masks, start_dt, end_dt)
  const now_ms = Date.now()
  if(!dt) return

  const delay = Math.max(0, dt.valueOf() - now_ms)

  const job = {
    masks,
    start: dt.valueOf(),
    time: dt.valueOf(),
  }

  job.stop = function() {
    if(job.timer) {
      clearTimeout(job.timer)
      job.timer = null
    }
    job.time = null
  } // stop

  job.fire = function() {
    try {
      fcn()
    }catch(err) {
      console.error(`Error in scheduled function (${masks}):`, err)
    }
    let new_dt = null
    if(!just_once) {
      // reschedule for the next matching time
      new_dt = mcron.findClosestMatchingTime(masks, job.time + 1_000, end_dt)
    }
    if(new_dt) {
      job.time = new_dt.valueOf()
      const delay = Math.max(0, job.time - Date.now())
      job.timer = setTimeout(job.fire, delay)
    }else {
      job.timer = null
      job.time = null
    }
  }

  job.timer = setTimeout(job.fire, delay)

  return job
} // schedule

mcron.scheduleOnce = function(masks, fcn, start_dt, end_dt) {
  return mcron.schedule(masks, fcn, start_dt, end_dt, true)
} // scheduleOnce
